// @ts-strict-ignore
import { Component, EventEmitter, HostBinding, Input, NgZone, OnInit, Output } from '@angular/core';
import { LandmarkPanel } from '@form/lm-form.model';
import { lmCardViewFormatter } from '@list/formatters/lm-card-view.formatter';
import { LMFormatterService } from '@list/formatters/lm-formatter.service';
import { LMListCardService } from '@list/services/lm-list-card.service';
import { LMFormatUtilService } from '@services/utils/lm-format-util.service';
import { LMThemeService } from '@banner/lm-theme.service';
import { LMErrorUtilService, LMUrlUtilService } from '@services/utils';
import { AppConstants } from '@utils/app.constants';
import { LMGlobalPersonalizationService } from '@app/states';
import { LMTwelveColumnPanelBaseComponent } from './lm-twelve-column-panel-base.component';
import { LMSimpleProgressService } from '@field/simpleprogress/lm-simple-progress.service';
import { LMContextService, LMOverlayService } from "@app/services";
import { LMNavigationService } from '@app/components';

@Component({
  selector: 'lm-twelve-column-panel-card',
  standalone: false,
  templateUrl: './lm-twelve-column-panel-card.component.html',
})

export class LMTwelveColumnPanelCardComponent extends LMTwelveColumnPanelBaseComponent implements OnInit {
  @HostBinding() public id;
  @HostBinding('attr.data-automation-id') public automationId;

  @Input() panel: LandmarkPanel;
  @Input() messageRuleView: LMDataView;

  @Input() set fromDataView(dataView) {
    this._dataView = dataView;
    this.build();
  }

  @Output() uiLinkEvent = new EventEmitter<any>();

  public columnInfo: string;
  public overNavigationLink: string;
  public hasOverviewNavigation: boolean;
  public displayLinkAsText: boolean;

  private _dataView: LMDataView;
  public isInAccessibilityMode: boolean;
  public drillAroundWindow = false;

  constructor(
    private lmContextService: LMContextService,
    private lmFormatterService: LMFormatterService,
    private lmListCardService: LMListCardService,
    private lmFormatUtilService: LMFormatUtilService,
    protected lmThemeService: LMThemeService,
    protected lmUrlUtilService: LMUrlUtilService,
    private lmGlobalPersonalizationService: LMGlobalPersonalizationService,
    private lmSimpleProgressService: LMSimpleProgressService,
    protected lmOverlayService: LMOverlayService,
    protected lmNavigationService: LMNavigationService,
    protected lmErrorUtilService: LMErrorUtilService,
    protected zone: NgZone
  ) {
    super(lmThemeService, lmOverlayService, lmUrlUtilService, lmNavigationService, lmErrorUtilService, zone);
  }

  savePanelState(): void {}

  clearPanelState(): void {}

  ngOnInit() {
    this.isInAccessibilityMode = this.lmGlobalPersonalizationService.getAccessibilityMode();
    this.build();

    this.id = this.panel.id + AppConstants.ELEMENT_ID_SUFFIX_DASHBOARDPANEL;
    this.automationId = `lm-${this.panel.automationId}-dashboardpanel`;

    if (this.lmContextService.drillAroundWindow()) {
      this.drillAroundWindow = true;
    }

    if (this.panel.overviewNavigation && !this.drillAroundWindow) {
      this.hasOverviewNavigation = true;
      if (this.panel.overviewNavigation.label) {
        this.displayLinkAsText = true;
      }
    }
  }

  build() {
    if (this.panel && this._dataView) {
      this.columnInfo = this.LMCardViewFormatter(0, 0, 0, { displayField: this.panel.displayFields[ 0 ] }, this._dataView, null);
      if (this.panel.overviewNavigation && this.panel.overviewNavigation.label && !this.drillAroundWindow) {
        this.overViewNavigationLabel();
      }
      this._setContentClasses(this.panel);
    }
  }

  overViewNavigationLabel() {
    const dataView = this.fromDataView ? this.fromDataView : this.messageRuleView;
    this.overNavigationLink = this.lmFormatUtilService.formatMessageRule(this.panel.overviewNavigation.label, dataView);
  }

  // eslint-disable-next-line max-len
  LMCardViewFormatter = (
    row: number,
    cell: number,
    value: any,
    columnDef: ListGridColumn,
    dataView: LMDataView,
    dataGrid: SohoDataGridStatic
  ): string => lmCardViewFormatter.format(
    this.lmFormatterService,
    this.lmListCardService,
    this.lmUrlUtilService,
    this.lmSimpleProgressService,
    row,
    cell,
    value,
    columnDef,
    dataView,
    dataGrid,
    'lm-dashboard-card-container',
    this.panel.automationId
  );

  onNavigationClick(event, displayField?: LMListDisplayField) {
    let df: LMListDisplayField;

    if (displayField === undefined) {
      df = {
        columnId: '',
        fieldId: '',
        type: '',
        navigation: this.panel.overviewNavigation.name,
        openInOverlay: this.panel.overviewNavigation.openInOverlay,
        navigationTargetComponent: this.panel.overviewNavigation.navigationTargetComponent
      };
    } else {
      df = displayField;
    }

    const uiLink: LMUILinkEvent = {
      columnDef: { displayField: df },
      dataView: this._dataView,
      event,
      options: { fromDashboard: true }
    };

    this.uiLinkEvent.emit(uiLink);
  }

  onWidgetContentClick(event) {
    if (event && event.target.nodeName === 'A' && event.target.dataset.displayfield !== undefined) {
      this.onNavigationClick(event, JSON.parse(event.target.dataset.displayfield));
    }
  }
}
